import React, { useState, useEffect } from "react";
import axios from "axios";
import { useAuth0 } from "@auth0/auth0-react";
import Header from "./Header";
import BaseContainerDividingLineRHSSidebar from "./BaseContainerDividingLineRHSSidebar";
import RunOptimalPlanButton from "./RunOptimalPlanButton";
import OptimizeButton from "./OptimizeButton";
import OptimizeDropdown from "./OptimizeDropdown";
import CustomSelectOptimize from "./CustomSelectOptimize";
import EndOfLifePage from "./EndOfLifePage";
import NextButton from "./NextButton";
import BackButton from "./BackButton";
import "./LifeStrategy.css";


const LifeStrategy = () => {
    const [optimize, setOptimize] = useState("select-optimization");
    const [customValue, setCustomValue] = useState(false);
    const [maxValue, setMaxValue] = useState('');
    const [choosePlan, setChoosePlan] = useState(false);

    const { user } = useAuth0();

    useEffect(() => {
        optimize === "Custom Value" ? setCustomValue(true) : setCustomValue(false);
    }, [optimize]);

    const handleOnChange = (e) => {
        setOptimize(e.target.value);
    }

    function renderResults(){
        let result;
        optimize === "select-optimization"
            ? (result = "Select Optimization Strategy")
            : (result = optimize);
        return result;
    };


    const onSubmit = (e) => {
        e.preventDefault();
        setChoosePlan(true);
        // let jsonObject = JSON.stringify({})
        axios.get(`http://localhost:4000/Optimized/?UserID=${user.sub}`)
        .then(response => {
            console.log(response)
            let jsonObject = JSON.stringify({
                // headers: {
                //     'Access-Control-Allow-Origin': '*',
                //     'Content-Type': 'application/json',
                //     'Accept': 'application/json'
                // },
                // mode: 'no-cors',
                Married: 'False',
                Name: response.data.data[0].FirstName,
                Birthday: response.data.data[0].birthday,
                Salary: response.data.data[0].Salary,
                Pension: response.data.data[0].Pension,
                RRSP: response.data.data[0].RRSP,
                JointStocks: '0',
                Stocks: response.data.data[0].NonReg,
                TFSA: response.data.data[0].TFSA,
                CPI: '0.02',
                Growth: '0.07',
                Expenses: response.data.data[0].Expenses,
                AgeToRun: '85',
                OptimizationType: optimize,
                SetValue: '',
                Province: response.data.data[0].Province,
                HomeValue: "",
                LifeInsurance: "",
                Other: "",
                CPP: response.data.data[0].CPP
            })
            console.log(jsonObject);
            axios.post('http://3.16.129.179:8000/', jsonObject)
            .then(response => {
                console.log('RESPONSE: ', response)
                setMaxValue(response.data.EOL);
            })
            .catch(error => {
                console.log('ERROR: ', error);
            })
        })
        .catch(error => {
            console.log(error)
        })
    }

    return (
        <div>
            {!choosePlan && <div className="container-center-horizontal">
                <div className="optimize-home-page screen">
                    <div className="flex-col-26">
                        <Header />
                        <div className="overlap-group8">
                            <BaseContainerDividingLineRHSSidebar />
                            <div className="strategy-plan edit-profile-2">
                                <div className="change-plan-2 nunito-bold-black-20px">Strategy: {renderResults()}</div>
                            </div>
                            <p className="label-8 nunito-semi-bold-black-12px">This strategy will enable you to spend the max about each year whilst ensuring you’re money will last for the duration of the optimization analysis. The $ value at end of optimization analysis with run to $0.00.</p>
                            <p className="label-9 nunito-semi-bold-black-12px">This strategy will allow you to set a custom $ value you would like at the end of the optimization anaylsys, whilst allowing the max spend each year.</p>
                            <p className="label-10 nunito-semi-bold-black-12px">This strategy will maximize the  growing your portfolio to ensure the</p>
                            <div className="label-11 nunito-semi-bold-shuttle-gray-14px">Customize estate value</div>
                            <p className="label-12 nunito-semi-bold-shuttle-gray-14px">Maximize amount of annual dollars spend with no estate value</p>
                            <p className="label-13 nunito-semi-bold-shuttle-gray-14px">Maximize value of portfolio for estate"</p>
                            <div className="label-14 nunito-bold-black-14px">Set Value:</div>
                            <div className="label-15 nunito-bold-black-14px">Max Spend:</div>
                            <div className="label-16 nunito-bold-black-14px">Max Value:</div>
                            <p className="label-17 nunito-semi-bold-shuttle-gray-14px">Select you’re desired optimization strategy</p>
                            <div className="rectangle-6457-6 border-1px-athens-gray-2"></div>
                            <div className="rectangle-6458-3 border-1px-athens-gray-2"></div>
                            <div className="optimize-21 nunito-bold-black-30px">Optimize</div>
                            <RunOptimalPlanButton />
                            
                            <div className="change-plan">
                                <div className="opt-strat-header nunito-bold-black-20px">Desired Optimization Strategy</div>
                            </div>
                            <div className="edit-profile-state-province">
                                <div className="overlap-group2-7">
                                    <form onSubmit={onSubmit}>
                                        <select 
                                            placeholder="Optimization Selection" 
                                            className="group-1000006369 border-1px-mischka nunito-semi-bold-shuttle-gray-14px" 
                                            value={optimize} 
                                            onChange={handleOnChange}
                                        >
                                            <option value="select-optimization">Optimization Strategy</option>
                                            <option value="Max Value">Max Value</option>
                                            <option value="Max Spend">Max Spend</option>
                                            <option value="Custom Value">Custom Value</option>
                                        </select>
                                        <button type="submit" className="optimize-save-button">Optimize</button>
                                    </form>
                                </div>
                            </div>
                            {customValue && <CustomSelectOptimize />}
                            <NextButton nextPage="/profile" />
                            <BackButton backPage="/expenses" />
                        </div>
                    </div>
                </div>
            </div>}
            {choosePlan && <EndOfLifePage maxValue={maxValue} />}
        </div>
    )
}

export default LifeStrategy;